<div class="wizard-header {{wizard_class}} clearfix">
    <ul class="steps">
        {{#each tabs}}
            <li class="{{#if isFirst}}first{{/if}} {{#if isSelected}}current{{else}}disabled{{/if}} {{#if isLast}}last{{/if}}">
                <div>
                    <span class="number">{{idx}}.</span> {{title}}
                </div>
            </li>
        {{/each}}
    </ul>
</div>

{{{content}}}
